// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["dated"]
  connect() {
    liveSearch()
  } 

  nextWeek(e) { 
    this.changeDate(e,  7 )
    this.refreshAllColumns()
  }
  prevWeek(e) { 
    this.changeDate(e,  -7 )
    this.refreshAllColumns()
  }
  next(e) {
    this.changeDate(e,  1)
    this.refreshAllColumns()
  }
  prev(e) { 
    this.changeDate(e,  -1)
    this.refreshAllColumns()
  }

  refreshAllColumns(date) {
    // This catches the user changing the date by the Next/Prev buttons
    history.replaceState("","",`reads?dated=${this.datedTarget.value}`)
    if ( document.querySelector(`#matched_dwell`) ) document.querySelector(`#matched_dwell`).value = "";
    if ( document.querySelector("#client_picker #dated").value ) document.querySelector("#client_picker #dated").value = this.datedTarget.value;
    document.querySelector("#control_date").closest('form').dispatchEvent(new Event('input'))
    this.refresh("unmatched_payments")
    this.refresh("matched")
    this.refresh("unmatched")
    this.refresh("mitigated")
  }

  update(e) {
    e.preventDefault()
    this.refreshAllColumns()
  }  

  refresh(sel) {
    if (document.querySelector(`#${sel}_tag`)) document.querySelector(`#${sel}_tag`).value = "";
    if (document.querySelector(`#${sel}_dated`)) document.querySelector(`#${sel}_dated`).value = this.datedTarget.value;
    if (document.querySelector(`#${sel}_dated`)) document.querySelector(`#${sel}_dated`).closest('form').dispatchEvent(new Event('input'));
  }

  changeDate(e, days) {
    //
    // This catches the user changing the date by the Next/Prev buttons
    // Update both colums and the control date form 
    //
    // !!!  Strange issue manifested on the 27th March
    //      When asking for next day, it gives 27th March! (Note this is one week and a day since the clocks changed)
    //      It's something to do with BST, but I am ignoring it for the moment,
    //      as the user can just click the calendar to get to the next date
    e.preventDefault()
    let d = new Date( this.datedTarget.value )
    d = d.setDate( d.getDate() + days )
    this.datedTarget.value = new Date(d).toISOString().split("T")[0]
  }
}
